module.exports = __webpack_public_path__ + "img/compare1.dbeeed01.png";